import { NavigatorAutocomplete } from "./components/NavigatorAutocomplete";
import { NavigatorProvider } from "./context/NavigatorProvider";

export const Navigator = () => (
  <NavigatorProvider>
    <NavigatorAutocomplete />
  </NavigatorProvider>
);
